"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialOfferForm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const commercial_offer_1 = require("../../../model/commercial_offer");
const helpers_1 = require("../../../utils/helpers");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const notification_center_1 = require("../../../widgets/notification_center");
const right_panel_1 = require("../../../widgets/right_panel");
const commercial_offer_show_1 = require("./commercial_offer_show");
const commercial_offer_table_1 = require("./commercial_offer_table");
function renderForm(form) {
    let value = (0, helpers_1.dig)(form.obj.value, "raw") || 0;
    return [
        form.errorBlock(),
        (0, form_for_1.fieldset)("Géneral", {}, (0, form_for_1.columns)(form.field("Nom du forfait", "name", "text", { placeholder: "Forfait 20 heures" })), (0, form_for_1.columns)(form.checkbox("Le forfait est actif", "active"))),
        (0, form_for_1.fieldset)("Heures", {}, form.field("Temps total (minutes)", "total_minutes", "number", { min: 60, step: 30 }), form.field("Quota d'annulation libre (minutes)", "free_cancel_minutes", "number", { min: 0, step: 30 })),
        (0, form_for_1.fieldset)("Conditions", {}, form.field("Nombre de paiements", "installment_count", "number", { min: 0 }), form.field("Période de validité (en mois)", "validity_period", "number", { min: 1 }), form.checkbox("Période démarrant au moment de la signature ?", "starts_at_creation")),
        (0, form_for_1.fieldset)("Tarification", {}, (0, form_for_1.columns)(form.field("Prix total (HT)", "value", "number", {
            step: 0.01,
            renderValue: (0, helpers_1.renderMoneyInput)(),
            transformValue: (0, helpers_1.transformMoneyInput)((value) => {
                form.obj.value_ttc = (0, helpers_1.withVAT)(value);
            })
        }), form.field("Prix total (TTC)", "value_ttc", "number", {
            step: 0.01,
            renderValue: (0, helpers_1.renderMoneyInput)(),
            transformValue: (0, helpers_1.transformMoneyInput)((value) => {
                form.obj.value = { raw: Math.round(value.raw / (app_1.App.VAT_RATE + 1)) };
            })
        })), (0, mithril_1.default)("div", "Prix HT (TTC):", (0, mithril_1.default)("strong", `${((value / 100) / (form.obj.total_minutes / 60)).toFixed(2)}`), " (", (0, mithril_1.default)("strong", `${((app_1.App.VAT_RATE + 1) * (value / 100) / (form.obj.total_minutes / 60)).toFixed(2)}`), ") EUR/H"))
    ];
}
exports.CommercialOfferForm = {
    commercialOffer: {},
    active: false,
    reset() {
        this.commercialOffer = {
            active: true,
            installment_count: 1,
            validity_period: 1,
            starts_at_creation: false,
            total_minutes: 0,
            value: {
                raw: 0
            },
            value_ttc: {
                raw: 0
            }
        };
    },
    show(commercialOffer) {
        if (commercialOffer) {
            this.commercialOffer = commercialOffer;
            if (commercialOffer.id) {
                // Reload the contract
                commercial_offer_1.CommercialOfferProvider.show(this.commercialOffer.id).then((commercialOffer) => {
                    this.commercialOffer = commercialOffer;
                    this.commercialOffer.value_ttc = (0, helpers_1.withVAT)(this.commercialOffer.value);
                });
            }
        }
        else {
            this.reset();
        }
        this.active = true;
    },
    title() {
        if (this.commercialOffer.id !== undefined) {
            return `Editer offre commerciale #${this.commercialOffer.id}`;
        }
        else {
            return `Nouvelle offre commerciale`;
        }
    },
    view(_vnode) {
        let form = (0, form_for_1.formFor)(this.commercialOffer, commercial_offer_1.CommercialOfferProvider, (form) => {
            return (0, modal_1.modalCard)({
                title: this.title(),
                content: renderForm(form),
                foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit("Créer", {
                    onsubmit: (obj) => {
                        notification_center_1.Notification.success(`L'offre commerciale ${obj.id} a bien été créée.`, (0, mithril_1.default)("a", { href: "#", onclick: (evt) => { evt.preventDefault(); right_panel_1.RightPanel.open("commercial_offers", obj.id, "show"); } }, "Afficher"));
                        commercial_offer_table_1.CommercialOfferTable.fetch();
                        commercial_offer_show_1.CommercialOfferShow.fetch(obj.id);
                        exports.CommercialOfferForm.active = false;
                    }
                })),
                isActive: exports.CommercialOfferForm.active,
                onClose: () => { exports.CommercialOfferForm.active = false; }
            });
        });
        return form;
    }
};
exports.CommercialOfferForm.reset();
